// Imports
import { PortalContext } from "src/modules/01 Global/jsx/contexts.jsx";
import { Tooltip } from "src/modules/tooltip/jsx/component.jsx";
import { makeDate } from "src/lib/utils.js";

// Stateful components

export class ProgramFeesAndOptions extends React.Component{

    //
    // Lifecycle 
    //

    constructor(props) {
        super(props);

        this.state = {
            "fees_v1": null,
            "fees_v2": null,
            "show_breakdown": false,
            "active_fees": [],
            "payment_option": null
        };

        // Binds
        this.toggleFeeBreakdown = this.toggleFeeBreakdown.bind(this);
        this.toggleFeeItem = this.toggleFeeItem.bind(this);
        this.handlePaymentChange = this.handlePaymentChange.bind(this);
    }

    componentDidMount(){
        var this_component = this;

        // get relevant storage objects
        var my_fees_storage_v1 = squiz.fn.getStorage('getmyfees', 'session', 'json');
        var my_fees_storage_v2 = squiz.fn.getStorage('getmyfeesv2', 'session', 'json');
        var has_fees = false;

        if(my_fees_storage_v1 && my_fees_storage_v1['data']){
            my_fees_storage_v1 = my_fees_storage_v1['data'];
            has_fees = true;
        }
        
        if(my_fees_storage_v2 && my_fees_storage_v2['data']){
            my_fees_storage_v2 = my_fees_storage_v2['data'];
        } else {
            has_fees = false;
        }

        if(has_fees){

            this_component.setState({
                "fees_v1": my_fees_storage_v1,
                "fees_v2": my_fees_storage_v2,
            });
        }

    }

    //
    // Functions
    //


    // Toggle dropdown containing fee breakdown
    toggleFeeBreakdown(event) {
        var this_component = this;
        var open = !this_component['state']['show_breakdown'];
        
        this_component.setState({
            show_breakdown: open
        });
    }

    // Toggle individual fee items on mobile
    toggleFeeItem(event) {
        var this_component = this;
        var selected_index = event.currentTarget.dataset.index;
        
        var active_fees = this_component['state']['active_fees'];
        var updated_fees = [].concat(active_fees);
        var index_found = active_fees.indexOf(selected_index);
        if (index_found !== -1) {
            updated_fees.splice(index_found, 1);
        } else {
            updated_fees.push(selected_index);
        }

        this_component.setState({
            'active_fees': updated_fees
        });

    }

    // Select a payment option
    handlePaymentChange(event) {
        var this_component = this;
        var value = event.currentTarget.value;

        this_component.setState({
            payment_option: value
        });
    }

    // Get the relevant payment option tooltip
    getPaymentTooltip(all_tooltips, tooltip_label) {
        var required_tooltip = null;

        all_tooltips.forEach(function(tooltip, tooltip_index) {
            if(tooltip['name'] === tooltip_label) {
                required_tooltip = tooltip;
            }
        });

        return required_tooltip;
    }


    //
    // Render
    //

    // Render account balance section
    renderAccountBalance(){
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];
        var custom_text = configuration['fees']['account_balance'];

        var fees_v1 = this_component['state']['fees_v1'];
        var fees_v2 = this_component['state']['fees_v2'];

        var date_format = 'DD MMM YYYY';

        if (fees_v1) {
            var due_date = null;
            if (fees_v1['charges']) {
                if (fees_v1['charges'].length > 0) {
                    var sorted_charges = fees_v1['charges'].sort(function(a, b) {
                        var date_a = new Date(a['dueDate']).getTime();
                        var date_b = new Date(b['dueDate']).getTime();
    
                        if (date_a > date_b) {
                            return 1;
                        }
                        if (date_a < date_b) {
                            return -1;
                        }
                        return 0;
                    });
                    
                    due_date = makeDate(sorted_charges[0]['dueDate'], date_format);
                }
                
            }

            var show_total = false;
            if (typeof(fees_v1['totalDue']) !== 'undefined') {
                show_total = true;
            }
            if (typeof(fees_v1['errorMessage']) !== 'undefined') {
                if (fees_v1['errorMessage'] !== null) {
                    show_total = false;
                }
            }
            

            return (
                <div className="account-balance__wrapper">
                    <div className="account-balance__inner">
                        <h2 className="account-balance__title">
                            Account Balance
                        </h2>
                        <div className="account-balance__charge__wrapper">

                            {fees_v1 ? (
                                <>
                                    {show_total ? (
                                        <div className="account-balance__charge">
                                        ${(Math.round(fees_v1['totalDue'] * 100) / 100).toFixed(2)}
                                        </div>
                                    ) : (
                                        <div className="account-balance__charge">
                                        {custom_text['no_data']}
                                        </div>
                                    )}
                                    
                                    {due_date ? (
                                        <div className="account-balance__charge__due">
                                        due {due_date}
                                        </div>
                                    ) : null}
                                </>
                            ) : (
                                <>
                                    <div>Account balance not available</div>
                                </>
                            )}
                            
                        </div>

                        {fees_v2 ? (
                            <>
                                {this_component.renderFeeBreakdown(fees_v2['feeDetails'])}
                            </>
                        ) : (
                            <div>No fee breakdown available</div>
                        )}
                        
                        
                    </div>
                </div>

            );
        }

        return null;
    }

    renderFeeBreakdown(fees) {
        var this_component = this;
        var active = this_component['state']['show_breakdown'];
        var btn_class = active ? ' account-balance__breakdown__title--open' : '';
        var dropdown_class = active ? ' course-tile__assessment__dropdown--open' : '';

        if (fees) {
            if (fees.length > 0) {
                var courses = []
                fees.forEach(function(item, key) {
                    var course = item['courseDescription'];
                    
                    if (courses.indexOf(course) === -1) {
                        courses.push(course);
                    }
                });
                

                var fees_arr = [];
                for (var i in courses) {
                    var course = courses[i];

                    var main_charge = fees.filter(function(item, key) {
                        return (item['courseDescription'] === course && item['chargeType'] === "Student Contribution Charge");
                    });

                    var sub_charges = fees.filter(function(item, key) {
                        return (item['courseDescription'] === course && item['chargeType'] !== "Student Contribution Charge");
                    });

                    if (main_charge.length > 0) {
                        fees_arr.push({
                            id: i,
                            courseDescription: course,
                            dueDate: main_charge[0]['dueDate'],
                            termDescription: main_charge[0]['termDescription'],
                            chargeAmount: main_charge[0]['chargeAmount'],
                            remaining: main_charge[0]['remaining'],
                            subCharges: sub_charges
                        });
                    } else {
                        fees_arr.push({
                            id: i,
                            courseDescription: course,
                            subCharges: sub_charges
                        });
                    }

                }

                
                return (
                    <>
                        <div className="account-balance__breakdown__wrapper">
                            <button className={"account-balance__breakdown__title" + btn_class} onClick={this_component.toggleFeeBreakdown}>
                                {active ? 'Hide details' : 'View fee breakdown'}
                            </button>
                        </div>
                        <div className={"course-tile__assessment__dropdown" + dropdown_class}>
                            
                            {fees_arr ? fees_arr.map(function(course, course_key) {

                                var sub_charges = course['subCharges'];
                                return (
                                    <React.Fragment key={course_key}>
                                        {this_component.renderFeeItem(course, course['id'] + 'M' + course_key)}
                                        
                                        {sub_charges.map(function(sub_charge, charge_key) {
                                            return (
                                                <React.Fragment key={charge_key}>
                                                    {this_component.renderFeeItem(sub_charge, course['id'] + 'M' + course_key + 'S' + charge_key)}
                                                </React.Fragment>
                                            );
                                            
                                        })}
                                        
                                    </React.Fragment>
                                )
                                    
                            }): null}

                        </div>
                    </>
                )
            }
        }

        return null;
    }

    renderFeeItem(course, key) {
        var this_component = this;

        var course_title = null;
        var course_description = null;
        var item_class = '';
        var date_format = 'DD MMM YYYY';
        var due_date = null;

        if(course['dueDate']) {
            due_date = makeDate(course['dueDate'], date_format);
        }

        if (typeof(course['chargeType']) !== 'undefined') {
            course_title = (
                <>
                <span className="desktop--hide">{course['courseDescription'].split(',')[0] + ', '}</span>{course['chargeType']}
                </>
            );
            course_description = course['chargeType'];
        } else {
            item_class = ' course-tile__assessment__item--main';
            course_title = course['courseDescription'];
            course_description = course['courseDescription'];
        }

        var item_state = '';
        var active_fees = this_component['state']['active_fees'];
        if (active_fees.indexOf(key) !== -1) {
            item_state = " course-tile__assessment__item--open";
        }

        return (
            <div className={"course-tile__assessment__item" + item_state + item_class}>
                
                {course['chargeAmount'] ? (
                    <button className="course-tile__assessment__item__toggler" data-index={key} onClick={this_component.toggleFeeItem}>
                        {course_title}
                    </button>
                ) : null}
                
                <div className="course-tile__assessment__item__col">
                    <div className="course-tile__assessment__item__title">
                        Charge
                    </div>
                    <div className="course-tile__assessment__item__info">
                        {course_description}
                    </div>
                </div>
                <div className="course-tile__assessment__item__col course-tile__assessment__item__col--narrow-hide">
                    <div className="course-tile__assessment__item__title">
                        Term
                    </div>
                    <div className="course-tile__assessment__item__info">
                        {course['termDescription'] ? course['termDescription'] : ''}
                    </div>
                </div>
                <div className="course-tile__assessment__item__col">
                    <div className="course-tile__assessment__item__title">
                        Amount
                    </div>
                    <div className="course-tile__assessment__item__info">
                        {course['chargeAmount'] ? (
                            <>
                            ${(Math.round(course['chargeAmount'] * 100) / 100).toFixed(2)}
                            </>
                        ) : null}
                    </div>
                </div>
                <div className="course-tile__assessment__item__col">
                    <div className="course-tile__assessment__item__title">
                        Due date
                    </div>
                    <div className="course-tile__assessment__item__info">
                        {due_date}
                    </div>
                </div>
                <div className="course-tile__assessment__item__col">
                    <div className="course-tile__assessment__item__title">
                        Remaining
                    </div>
                    <div className="course-tile__assessment__item__info">
                        {course['remaining'] ? (
                            <>
                                ${(Math.round(course['remaining'] * 100) / 100).toFixed(2)}
                            </>
                        ) : null}
                    </div>
                </div>
            </div>
        )
    }

    renderPaymentOptionTooltip(tooltip_type) {
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];
        var current_page = portal_context['current_page'];
        var payment_options = configuration['fees']['payment_options'];

        var helpers = portal_context['helpers'];
        var page_data = helpers.getPageBySlug(current_page);
        var all_tooltips = page_data['content']['tooltips'];
        var payment_options_tooltips = all_tooltips['payment_options'];
        var tooltip_data = this_component.getPaymentTooltip(payment_options_tooltips, tooltip_type);
        var tooltip_label = payment_options[tooltip_type]['title'];
        
        if(tooltip_data !== null) {
            return this_component.renderTooltip(tooltip_data, tooltip_label);           
        }

        return tooltip_label;
    }

    renderTooltip(active_tooltip, tooltip_label) {
        var tooltip_content = {
            'title': active_tooltip['title'],
            'info': active_tooltip['message'],
            'link': active_tooltip['link'],
            'link_text': active_tooltip['link_text'],
            'button': {
                'class': 'payment-options__btn',
                'text': tooltip_label
            }
        };

        return <Tooltip content={tooltip_content} />
    }

    
    renderPaymentOptions(){
        var this_component = this;
        var portal_context = this_component['context'];
        var configuration = portal_context['configuration'];
        var helpers = portal_context['helpers'];

        var fees_v1 = this_component['state']['fees_v1'];
        
        if (fees_v1) {
            
            var payment_due = false;
            if (typeof(fees_v1['totalDue']) !== 'undefined') {
                if (fees_v1['totalDue'] > 0) {
                    payment_due = true;
                }
            }
            if (typeof(fees_v1['errorMessage']) !== 'undefined') {
                if (fees_v1['errorMessage'] !== null) {
                    payment_due = false;
                }
            }

            if (payment_due) {
                var selected_option = this_component['state']['payment_option'];
                var payment_options = configuration['fees']['payment_options'];
                var selected_link = payment_options[selected_option] ? helpers.getDynamicLinkUrlById(payment_options[selected_option]['link']) : '#';

                var credit_card_heading = this_component.renderPaymentOptionTooltip('credit_card');
                var bpay_heading = this_component.renderPaymentOptionTooltip('bpay');
                var western_union_heading = this_component.renderPaymentOptionTooltip('western_union');

                return (
                    <div className="payment-options__wrapper">
                        <h2 className="payment-options__title">Payment options</h2>
                        <ul className="payment-options__list">
                            <li className="payment-option__list__item">
                                <input type="radio" name="payment-option" id="credit-card" value="credit_card" className="payment-option__list__item__input" defaultChecked={selected_option === 'credit_card'} onChange={this_component.handlePaymentChange} />
                                <label htmlFor="credit-card" className="payment-option__list__item__label">
                                    <span className="payment-option__list__item__ring"></span>
                                    <span className="payment-option__list__item__title">
                                        {credit_card_heading}
                                    </span>
                                    <span className="payment-option__list__item__item__info">
                                        {payment_options['credit_card']['help_text']}
                                    </span>
                                    <span className="payment-option__list__item__background"></span>
                                </label>
                            </li>
                            <li className="payment-option__list__item">
                                <input type="radio" name="payment-option" id="bpay" value="bpay" className="payment-option__list__item__input" defaultChecked={selected_option === 'bpay'} onChange={this_component.handlePaymentChange} />
                                <label htmlFor="bpay" className="payment-option__list__item__label">
                                    <span className="payment-option__list__item__ring"></span>
                                    <span className="payment-option__list__item__title">
                                        {bpay_heading}
                                    </span>
                                    <span className="payment-option__list__item__item__info">
                                        <img src={configuration['images']['bpay.png']['url']} alt="bpay" className="payment-option__list__item__info__icon"/>
                                    </span>
                                    <span className="payment-option__list__item__item__info">
                                        {payment_options['bpay']['help_text']}
                                    </span>
                                    <span className="payment-option__list__item__background"></span>
                                </label>
                            </li>
                            <li className="payment-option__list__item">
                                <input type="radio" name="payment-option" id="western-union" value="western_union" className="payment-option__list__item__input" defaultChecked={selected_option === 'western_union'} onChange={this_component.handlePaymentChange} />
                                <label htmlFor="western-union" className="payment-option__list__item__label">
                                    <span className="payment-option__list__item__ring"></span>
                                    <span className="payment-option__list__item__title">
                                        {western_union_heading}
                                    </span>
                                    <span className="payment-option__list__item__item__info">
                                        {payment_options['western_union']['help_text']}
                                    </span>
                                    <span className="payment-option__list__item__background"></span>
                                </label>
                            </li>
                        </ul>
                        <div className="payment-options__submit__wrapper">
                            <a href={selected_link} className={"payment-options__submit" + (!selected_option ? ' disabled' : '')} >Proceed to payment</a>
                        </div>
                    </div>
                );
            }
        }

        return null;
    }


    render() {
        var this_component = this;
        var account_balance = this_component.renderAccountBalance();
        var payment_options = this_component.renderPaymentOptions();

        return (
            <>
                {account_balance}
                {payment_options}
            </>
        );
    }

};

ProgramFeesAndOptions.contextType = PortalContext;
